/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Footer/view.blocks to change it.
import CancelAction from './CancelAction/index'
import CreateAction from './CreateAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Footer({
  children,
  viewPath = "/App/Account/Content/Tasks/New/NewTaskOverlay/Content/Footer"
  
}) {
  return (<React.Fragment
>
<CreateAction
  viewPath={`${viewPath}/CreateAction`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
{children}
</React.Fragment>)
}